module.exports = __webpack_public_path__ + "static/media/bg.b8c69c5e.png";